import {
  AddCircleOutline as AddCircleOutlineIcon,
  AppRegistration as AppRegistrationIcon,
  DataArray as DataArrayIcon,
  Delete as DeleteIcon,
  Folder as FolderIcon,
  GroupsOutlined as GroupsIcon,
  Public as PublicIcon,
  QuestionAnswer as QuestionAnswerIcon,
  UnfoldMore as UnfoldMoreIcon,
  Search as SearchIcon,
  Settings as SettingsIcon,
  DeviceHub as DeviceHubIcon,
} from '@mui/icons-material';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  TextField,
  Toolbar,
  Tooltip,
  Typography,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Menu,
  Paper
} from '@mui/material';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, connect } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { RiRobot2Line } from "react-icons/ri";
import { RxDashboard } from "react-icons/rx";
import { HiOutlineRectangleStack } from "react-icons/hi2";
import { TbApiApp } from "react-icons/tb";
import { FaListUl } from "react-icons/fa6";
import { HiPencilAlt } from "react-icons/hi";
import { FiClock } from "react-icons/fi";
import { PiBracketsCurlyDuotone } from "react-icons/pi";
import { MdOutlineMemory } from "react-icons/md";
import { TbFileTypeJs } from "react-icons/tb";
import { TbReport } from "react-icons/tb";

// Assets
import './CustomSidebar.css';
import './index.css';

// Components
import BuildReportsPage from '../BuildReports/BuildReportsPage.jsx';
import CollectionSidebar from '../Collections/CollectionSidebar';
import CustomSnackbar from '../Common/CustomSnackbar';
import ChatsPage from '../Chats/ChatsPage.jsx';
import FunctionsPage from '../Functions/FunctionsPage.jsx';
import OrganisationScreen from '../Organisation';
import ProjectScreen from '../Project';
import PublicPage from '../PublicPage/PublicPage.jsx';
import SettingsPage from '../Settings/SettingsPage.jsx';
import TestPlanBuildPage from '../TestPlanBuilds/TestPlanBuildsPage.jsx';
import TestPlanPage from '../TestPlans/TestPlanPage.jsx';
import TestScenarioBuildPage from '../TestScenarioBuildLogs/TestScenarioBuildPage';
import TestScenariosPage from '../TestScenarios/TestScenariosPage';
import TestSuiteBuildsPage from '../TestSuiteBuilds/TestSuiteBuildsPage.jsx';
import TestSuitesPage from '../TestSuites/TestSuitesPage.jsx';
import VariableSetPage from '../VariableSet/VariableSetPage';
import NavigationDrawer from './NavigationDrawer.jsx';
import FAQPage from '../FAQs/FAQPage.jsx';
import CollectionForksPage from 'components/CollectionForks/CollectionForksPage';
import ConfirmationDialog from '../Dialog/ConfirmationDialog';
import { drawerWidth, COLLAPSED_WIDTH } from 'config/constants';
import { useSidebar } from '../../contexts/SidebarContext';

import { apiAgent } from '../../config/axiosConfig';
import { useSnackbar } from '../../contexts/CustomSnackbarContext';
import { useGuestUser } from '../../contexts/GuestUserContext';
import {
  deleteProjectMember,
  fetchProjectMembers,
  getProject,
  inviteByEmail,
  updateUserRoleForProject,
  getUserDetails
} from '../../redux-store/currentUserActions';
import { resetTabs } from '../../redux-store/tabSlice';
import { MixpanelService } from '../../utils/mixpanelService';
import ProfileScreen from '../Account/Profile';
import LoadingOverlay from '../Common/LoadingOverlay';
import { fetchOrganisations as fetchGlobalOrganisations } from 'redux-store/dashboardActions';
import { setSelectedProject, setSelectedOrganisation } from 'reducers/commonSlice.js';
import { userLogOut } from 'redux-store/currentUserSlice';
import MemoryPage from 'components/Common/Memory/MemoryPage';
import DashboardPage from 'components/DashboardComponent/DashboardPage';
import IntroTour from 'components/IntroTour/IntroTour';
import { PopupButton } from 'react-calendly';
import customUtils from 'utils/customUtils';
import TransactionHistory from 'components/TransactionHistory/TransactionHistory';
import { LOCAL_STORAGE_KEY_FOR_ENVIRONMENT } from 'config/constants';
import SupabaseComponent from 'components/Oauth/SupabaseComponent';
import GithubComponent from 'components/Oauth/GithubComponent';
import TestCaseGeneratorBot from 'components/TestCaseGeneratorBot/TestCaseGeneratorBot';
import { RESET_STORE } from "redux-store/store";
import ApiOverview from 'components/ApiCollectionOverview/ApiOverview/ApiOverview';
import { inviteGitHubUser } from 'redux-store/testScenarioReducers/testScenarioActions';
import AiAgentHeader from 'components/TestCaseGeneratorBot/AiAgentHeader';
import { Home } from 'lucide-react';
import QuickStart from 'components/QuickStart/QuickStart';

// TODO: Add a new menu item for Runs

const sideBarDropdownMap = {
  "data": ["environments", "memory", "data-sets", "js-functions"],
  "plan": ["test-scenarios", "test-suites", "test-plans"],
  "apiDocs": ["public-page", "search", "faqs", "collection-forks"]
}

const DashboardScreen = ({ user, selectedProject, selectedOrganisation, organisations }) => {
  // State and Hooks
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    collectionSlug,
    folderSlug,
    entitySlug,
    testScenarioId,
    testScenarioBuildId,
    variableSetId,
    testSuiteId,
    testSuiteBuildId,
    testPlanId,
    testPlanBuildId,
    chatId,
    faqSlug
  } = useParams();
  const { openSnackbar } = useSnackbar();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const dropdownRef = useRef(null);
  const { isGuestUser } = useGuestUser();

  const [showGuideModal, setShowGuideModal] = useState(false);
  const [projectMenuAnchor, setProjectMenuAnchor] = useState(null);
  const [isCollectionSidebar, setCollectionSidebar] = useState(true);
  const [orgId, setOrgId] = useState();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isOrgModalOpen, setIsOrgModalOpen] = useState(false);
  const [isProfileScreenDialogOpen, setIsProfileScreenDialogOpen] =
    useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState(collectionSlug);
  const [selectedFolder, setSelectedFolder] = useState(folderSlug);
  const [selectedEntity, setSelectedEntity] = useState(entitySlug);
  const [selectedTestScenarioId, setSelectedTestScenarioId] =
    useState(testScenarioId);
  const [selectedTestScenarioBuildId, setSelectedTestScenarioBuildId] = useState(testScenarioBuildId);
  const [selectedVariableSetId, setSelectedVariableSetId] =
    useState(variableSetId);
  const [selectedTestSuiteId, setSelectedTestSuiteId] = useState(testSuiteId);
  const [selectedTestSuiteBuildId, setSelectedTestSuiteBuildId] = useState(testSuiteBuildId);
  const [selectedTestPlanId, setSelectedTestPlanId] = useState(testPlanId);
  const [selectedTestPlanBuildId, setSelectedTestPlanBuildId] =
    useState(testPlanBuildId);
  const [selectedChatId, setSelectedChatId] = useState(chatId);
  const [selectedFaqSlug, setSelectedFaqSlug] = useState(faqSlug);

  const [isInvitationModalOpen, setIsInvitationModalOpen] = useState(false);
  const [inviteEmail, setInviteEmail] = useState('');
  const [inviteName, setInviteName] = useState('');

  const [invitationProjectId, setInvitationProjectId] = useState(null);
  const [emailError, setEmailError] = useState('');
  const [nameError, setNameError] = useState('');

  const [isSending, setIsSending] = useState(false);
  const [emailSentMessage, setEmailSentMessage] = useState('');
  const [nameSentMessage, setNameSentMessage] = useState('');

  const [generatedLink, setGeneratedLink] = useState('');
  const [projectMembers, setProjectMembers] = useState([]);
  const [filter, setFilter] = useState('all');
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = useState(false);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const orgModalRef = useRef(null);
  const projectModalRef = useRef(null);
  const profileModalRef = useRef(null);
  const initialMount = useRef(true);
  const [selectedInviteRole, setSelectedInviteRole] = useState("");
  const [filteredMembers, setFilteredMembers] = useState([]);

  const [gitHubInvitationModalOpen, setGitHubInvitationModalOpen] = useState(false);
  const [gitHubUsername, setGitHubUsername] = useState(null);

  const eligibleForSidebar = [
    'ai-agent',
    'collections',
    'members',
    'test-scenarios',
    'test-scenario-builds',
    'environments',
    'test-suites',
    'test-suite-builds',
    'test-plans',
    'test-plan-builds',
    'build-reports',
    'js-functions',
    'data-sets',
    'settings',
    'public-page',
    'search',
    'faqs',
    'collection-forks',
    'memory',
    'dashboard',
    'api-overview',
    'quick-start',
  ];

  const customHeaderMenuItems = [
    'test-scenarios',
    'test-scenario-builds',
    'environments',
    'test-suites',
    'test-suite-builds',
    'test-plans',
    'test-plan-builds',
    'build-reports',
    'js-functions',
    'data-sets',
    'settings',
    'public-page',
    'search',
    'faqs',
    'collection-forks',
    'memory',
    'transactions',
    'api-overview',
    'quick-start',
  ]
  const getSelectedMenuItem = () => {
    if (history.location.pathname.startsWith('/members')) return 'members';
    if (history.location.pathname.startsWith('/test-scenarios') && history.location.pathname.includes('/build'))
      return 'test-scenario-builds';
    if (history.location.pathname === '/test-scenario-builds/' || history.location.pathname === '/test-scenario-builds') {
      history.push("/test-scenarios/");
      return 'test-scenarios';
    }
    if (history.location.pathname.startsWith('/test-scenario-builds/'))
      return 'test-scenario-builds';
    if (history.location.pathname.startsWith('/test-scenarios'))
      return 'test-scenarios';
    if (history.location.pathname.startsWith('/environments')) {
      return 'environments';
    }
    if (history.location.pathname.startsWith('/test-suites') && history.location.pathname.includes('/build'))
      return 'test-suite-builds';
    if (history.location.pathname === '/test-suite-builds/' || history.location.pathname === '/test-suite-builds') {
      history.push("/test-suites/");
      return 'test-suites';
    }
    if (history.location.pathname.startsWith('/test-suite-builds/')) {
      return 'test-suite-builds';
    }
    if (history.location.pathname.startsWith('/test-suites'))
      return 'test-suites';
    if (history.location.pathname.startsWith('/test-plans') && history.location.pathname.includes('/build'))
      return "test-plan-builds";
    if (history.location.pathname === '/test-plan-builds/' || history.location.pathname === '/test-plan-builds') {
      history.push("/test-plans/");
      return 'test-plans';
    }
    if (history.location.pathname.startsWith('/test-plan-builds/')) {
      return 'test-plan-builds';
    }
    if (history.location.pathname.startsWith('/test-plans'))
      return 'test-plans';
    if (history.location.pathname.startsWith('/build-reports'))
      return 'build-reports';
    if (history.location.pathname.startsWith('/js-functions'))
      return 'js-functions';
    if (history.location.pathname.startsWith('/data-sets'))
      return 'data-sets';
    if (history.location.pathname.startsWith('/settings'))
      return 'settings';
    if (history.location.pathname.startsWith('/public-page'))
      return 'public-page';
    if (history.location.pathname.startsWith('/search'))
      return 'search';
    if (history.location.pathname.startsWith('/faqs'))
      return 'faqs';
    if (history.location.pathname.startsWith('/collection-forks'))
      return 'collection-forks';
    if (history.location.pathname.startsWith('/memory'))
      return 'memory';
    if (history.location.pathname === '/dashboard')
      return 'dashboard';
    if (history.location.pathname.startsWith('/transactions'))
      return 'transactions';
    if (history.location.pathname.startsWith('/auth/supabase_callback'))
      return 'supabase_callback';
    if (history.location.pathname.startsWith('/auth/github_callback'))
      return 'github_callback';
    if (history.location.pathname.startsWith('/ai-agent'))
      return 'ai-agent';
    if (history.location.pathname.startsWith('/quick-start'))
      return 'quick-start';
    if (history.location.pathname.startsWith('/api-overview'))
      return 'api-overview';
    return 'collections';
  };

  const menuItems = [
    {
      label: 'Quick Start',
      id: 'quick-start',
      icon: <Home />,
      onClick: () => {
        handleTabClick('quick-start');
        history.push('/quick-start');
      },
      href: "/quick-start"
    },
    {
      label: 'AI Agent',
      id: 'ai-agent',
      icon: <RiRobot2Line />,
      onClick: () => {
        handleTabClick('ai-agent');
        history.push('/ai-agent?newChat=true');
      },
      href: "/ai-agent"
    },
    {
      label: 'Dashboard',
      id: 'dashboard',
      icon: <RxDashboard />,
      onClick: () => {
        handleTabClick('dashboard');
        history.push('/dashboard');
      },
      href: "/dashboard"
    },
    {
      label: 'Collections',
      id: 'collections',
      icon: <HiOutlineRectangleStack />,
      onClick: () => {
        handleTabClick('collections');
        handleCollectionSidebar('collections');
        history.push('/collections');
      },
      href: "/collections"
    },
    {
      label: 'API Overview',
      id: 'api-overview',
      icon: <TbApiApp />,
      onClick: () => {
        handleTabClick('api-overview');
        handleCollectionSidebar('api-overview');
        history.push('/api-overview');
      },
      href: "/api-overview"
    },
    {
      label: 'API Testing',
      id: 'plan',
      icon: <AppRegistrationIcon fontSize='large' sx={{ width: "18px", height: "18px" }} />,
      type: 'dropdown',
      items: [
        {
          label: 'Test Scenarios',
          id: 'test-scenarios',
          icon: <HiPencilAlt />,
          onClick: () => {
            handleTabClick('test-scenarios');
            handleCollectionSidebar('test-scenarios');
            history.push('/test-scenarios');
          },
          href: "/test-scenarios",
          parentItemId: 'plan'
        },
        {
          label: 'Test Suites',
          id: 'test-suites',
          icon: <FaListUl />,
          onClick: () => {
            history.push(`/test-suites/`);
            handleCollectionSidebar('test-suites');
            handleTabClick('test-suites');
          },
          href: "/test-suites",
          parentItemId: 'plan'
        },
        {
          label: 'Test Plans',
          id: 'test-plans',
          icon: <FiClock fontSize="large" />,
          onClick: () => {
            handleTabClick('test-plans');
            handleCollectionSidebar('test-plans');
            history.push(`/test-plans/`);
          },
          href: "/test-plans",
          parentItemId: 'plan'
        }
      ]
    },
    {
      label: 'Data',
      id: 'data',
      icon: <DataArrayIcon fontSize='large' sx={{ width: "18px", height: "18px" }} />,
      type: 'dropdown',
      items: [
        {
          label: 'Environments',
          id: 'environments',
          icon: <PiBracketsCurlyDuotone fontSize="large" />,
          onClick: () => {
            handleTabClick('environments');
            handleCollectionSidebar('environments');
            history.push('/environments');
          },
          href: "/environments",
          parentItemId: 'data'
        },
        {
          label: 'Memory',
          id: 'memory',
          icon: <MdOutlineMemory fontSize="large" />,
          onClick: () => {
            handleTabClick('memory');
            handleCollectionSidebar('memory');
            history.push('/memory');
          },
          href: "/memory",
          parentItemId: 'data'
        },
        {
          label: 'JS Functions',
          id: 'js-functions',
          icon: <TbFileTypeJs fontSize="large" />,
          onClick: () => {
            handleTabClick('js-functions');
            handleCollectionSidebar('js-functions');
            history.push('/js-functions');
          },
          href: "/js-functions",
          parentItemId: 'data'
        }
      ]
    },
    {
      label: 'Build Reports',
      id: 'build-reports',
      icon: <TbReport fontSize="large" />,
      onClick: () => {
        handleTabClick('build-reports');
        handleCollectionSidebar('build-reports');
        history.push(`/build-reports`);
      },
      href: "/build-reports"
    },
    {
      label: 'API Docs',
      id: 'apiDocs',
      icon: <PublicIcon fontSize='large' sx={{ width: "18px", height: "18px" }} />,
      type: 'dropdown',
      items: [
        {
          label: 'Settings',
          id: 'public-page',
          icon: <SettingsIcon fontSize="large" />,
          onClick: () => {
            handleTabClick('public-page');
            handleCollectionSidebar('public-page');
            history.push('/public-page');
          },
          href: "/public-page",
          parentItemId: 'apiDocs'
        },
        {
          label: 'Search',
          id: 'search',
          icon: <SearchIcon fontSize="large" />,
          onClick: () => {
            handleTabClick('search');
            handleCollectionSidebar('search');
            history.push('/search');
          },
          href: "/search",
          parentItemId: "apiDocs"
        },
        {
          label: 'FAQs',
          id: 'faqs',
          icon: <QuestionAnswerIcon fontSize="large" />,
          onClick: () => {
            handleTabClick('faqs');
            handleCollectionSidebar('faqs');
            history.push('/faqs');
          },
          href: "/faqs",
          parentItemId: "apiDocs"
        },
        {
          label: 'Collection Forks',
          id: 'collection-forks',
          icon: <DeviceHubIcon fontSize="large" />,
          onClick: () => {
            handleTabClick('collection-forks');
            handleCollectionSidebar('collection-forks');
            history.push('/collection-forks');
          },
          href: "/collection-forks",
          parentItemId: "apiDocs"
        }
      ]
    },
    {
      label: 'Team Members',
      id: 'members',
      icon: <GroupsIcon fontSize="large" />,
      onClick: () => {
        handleTabClick('members');
        handleCollectionSidebar('members');
        history.push('/members');
      },
      href: "/members"
    }
  ];

  const [selectedMenuItem, setSelectedMenuItem] = useState(
    getSelectedMenuItem()
  );

  useEffect(() => {
    const initComponent = async () => {
      if (!organisations || organisations.length == 0) {
        await dispatch(fetchGlobalOrganisations({}));
      }

      if (initialMount.current) {
        initTwitterTracking();
        initRedditTracking();
        initialMount.current = false;
      }

      function handleClickOutside(event) {
        if (orgModalRef.current && !orgModalRef.current.contains(event.target)) {
          setIsOrgModalOpen(false);
        }
        if (
          projectModalRef.current &&
          !projectModalRef.current.contains(event.target)
        ) {
          setIsModalOpen(false);
        }
        if (
          profileModalRef.current &&
          !profileModalRef.current.contains(event.target)
        ) {
          setIsProfileScreenDialogOpen(false);
        }
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setDropdownVisible(false);
        }
      }

      validateShowGuideModal();
      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    };

    // Initialize the component
    initComponent();
  }, [dispatch]);



  useEffect(() => {
    if (selectedProject) {
      fetchMembers();
      const selectedOrg = Array.isArray(organisations)
        ? organisations.filter(org => org?.id === selectedProject?.organisation_id)
        : [];
      if (selectedOrg?.[0]) {
        dispatch(setSelectedOrganisation({ ...selectedOrg[0] }));
      }
    }
  }, [selectedProject]);

  useEffect(() => {
    const selectedMenuItem = getSelectedMenuItem();
    setSelectedMenuItem(selectedMenuItem);
  }, [history.location.pathname]);

  useEffect(() => {
    validateShowGuideModal();
  }, [history.location.search])

  useEffect(() => {
    // TODO :: What if the collection slug is not valid?
    if (collectionSlug) {
      setSelectedCollection(collectionSlug);
    }

    if (folderSlug) {
      setSelectedFolder(folderSlug);
    }

    if (entitySlug) {
      setSelectedEntity(entitySlug);
    }
  }, [collectionSlug, folderSlug, entitySlug]);

  useEffect(() => {
    if (testScenarioId) {
      setSelectedTestScenarioId(testScenarioId);
    }
  }, [testScenarioId]);

  useEffect(() => {
    if (testScenarioBuildId) {
      setSelectedTestScenarioBuildId(testScenarioBuildId);
    }
  }, [testScenarioBuildId]);

  useEffect(() => {
    if (variableSetId) {
      setSelectedVariableSetId(variableSetId);
    }
  }, [variableSetId]);

  useEffect(() => {
    if (testSuiteId) {
      setSelectedTestSuiteId(testSuiteId);
    }
  }, [testSuiteId]);

  useEffect(() => {
    if (testSuiteBuildId) {
      setSelectedTestSuiteBuildId(testSuiteBuildId);
    }
  }, [testSuiteBuildId]);

  useEffect(() => {
    if (testPlanId) {
      setSelectedTestPlanId(testPlanId);
    }
  }, [testPlanId]);

  useEffect(() => {
    if (testPlanBuildId) {
      setSelectedTestPlanBuildId(testPlanBuildId);
    }
  }, [testPlanBuildId]);

  useEffect(() => {
    if (chatId) {
      setSelectedChatId(chatId);
    }
  }, [chatId]);

  useEffect(() => {
    if (faqSlug) {
      setSelectedFaqSlug(faqSlug);
    }
  }, [faqSlug]);


  const refreshSelectedProject = async () => {
    const response = await dispatch(getProject({ projectId: selectedProject?.id }));
    await dispatch(setSelectedProject(response.payload));
  }

  const refreshUserDetails = async () => {
    await dispatch(getUserDetails());
  }

  useEffect(() => {
    // Check if this is a true page refresh by using sessionStorage
    // sessionStorage persists only for the duration of the browser session
    // It gets cleared on page refresh, but persists on component re-mounts within the same session
    const hasRefreshed = sessionStorage.getItem('userDetailsRefreshed');

    if (!hasRefreshed) {
      refreshUserDetails();
      // Set a flag to prevent calling again on component re-mounts
      sessionStorage.setItem('userDetailsRefreshed', 'true');
    }

    // Add beforeunload listener to clear the flag on page refresh
    const handleBeforeUnload = () => {
      sessionStorage.removeItem('userDetailsRefreshed');
    };
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  useEffect(() => {
    // interval => 10 mins
    const intervalId = setInterval(refreshSelectedProject, 600000);
    return () => clearInterval(intervalId);
  }, [selectedProject]);


  // Functions and Handlers
  // Set the initial menu item based on the current route

  const initTwitterTracking = function () {
    if (window.twq) {
      window.twq('config', 'on7ou');
      window.twq('track', 'collection-view');
    }
  }

  const initRedditTracking = function () {
    if (window.rdt) {
      window.rdt('init', 'a2_fjjoqyuwczjo');
      window.rdt('track', 'PageVisit');
    }
  }

  const validateShowGuideModal = () => {
    if (history.location.search.indexOf("showGuide") !== -1) {
      setShowGuideModal(true);
      const currentLocation = history.location.pathname + history.location.search.replace("showGuide", "");
      history.replace(currentLocation);
    }
  }

  const closeSidebar = () => {
    handleCloseProjectMenu();
  };

  const fetchMembers = async () => {
    setIsLoading(true);
    const res = await dispatch(fetchProjectMembers(selectedProject.id));
    if (res.payload) {
      setProjectMembers([...res.payload] || []);
    }
    setIsLoading(false);
  };

  const openModal = (org) => {
    handleCloseProjectMenu();
    setIsModalOpen(true);
    setOrgId(org);
  };

  const openModalOrg = () => {
    handleCloseProjectMenu();
    setIsOrgModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsOrgModalOpen(false);
    fetchOrganisations();
  };

  const selectDefaultProject = async () => {
    if (selectedProject?.id) return;
    const lastProject = JSON.parse(localStorage.getItem('lastSelectedProject'));

    if (!lastProject && organisations.length > 0 && organisations[0].projects.length > 0) {
      const firstProject = organisations[0].projects[0];
      await updateSelectedProjectInState(firstProject?.id);
      localStorage.setItem('lastSelectedProject', JSON.stringify(firstProject));
      localStorage.removeItem(LOCAL_STORAGE_KEY_FOR_ENVIRONMENT);
    } else if (lastProject?.id) {
      await updateSelectedProjectInState(lastProject?.id);
    }
  }

  useEffect(() => {
    selectDefaultProject();
  }, [organisations]);

  const fetchOrganisations = async () => {
    await dispatch(fetchGlobalOrganisations({}));
  };

  useEffect(() => {
    const updateFilteredMembers = () => {
      const members = projectMembers.filter((member) => {
        switch (filter) {
          case 'joined':
            return member.status === 'joined';
          case 'pending':
            return member.status === 'pending';
          case 'all':
          default:
            return true;
        }
      });
      setFilteredMembers(members);
    };
    updateFilteredMembers();
  }, [projectMembers, filter]);

  const handleTabClick = (tab) => {
    handleCloseProjectMenu();
    if (eligibleForSidebar.indexOf(tab) !== -1) {
      setCollectionSidebar(true);
    } else {
      setCollectionSidebar(false);
    }
    // setExpandedNodeIds([])
    setSelectedMenuItem(tab);
  };

  const handleProjectClick = async (project, queryParams = "") => {
    dispatch(resetTabs());
    await updateSelectedProjectInState(project?.id);
    MixpanelService.track("project_selected", { project_id: project?.id });
    const selectedOrg = organisations?.filter(org => org?.id === project?.organisation_id);

    if (selectedOrg?.length?.[0]) {
      dispatch(setSelectedOrganisation({ ...selectedOrg[0] }));
    }

    localStorage.setItem('lastSelectedProject', JSON.stringify(project));
    localStorage.removeItem(LOCAL_STORAGE_KEY_FOR_ENVIRONMENT);
    closeSidebar();
    if (queryParams === "") {
      history.push(`/dashboard`);
    } else {
      window.open("/ai-agent", "_blank");
    }
  };

  const updateSelectedProjectInState = async (projectId) => {
    const response = await dispatch(getProject({ projectId: projectId }));
    await dispatch(setSelectedProject(response.payload));
  }

  const updateSelectedProject = (project) => {
    handleProjectClick(project, "showGuide=1");
  };

  const handleSelectClick = useCallback((event) => {
    setProjectMenuAnchor(event ? event.currentTarget : null);
  }, []);

  const handleCloseProjectMenu = () => {
    setProjectMenuAnchor(null);
  };

  const handleCollectionSidebar = (checkMenuItem) => {
    if (selectedMenuItem !== checkMenuItem)
      setCollectionSidebar((prevIsCollectionSidebar) => !prevIsCollectionSidebar);
  };

  const handleLogout = async () => {
    localStorage.clear();
    await dispatch(userLogOut());
    await dispatch({ type: RESET_STORE })
    history.push('/login', { showEmailSentMessage: false });
  };

  const openInvitationModal = (projectId) => {
    setInvitationProjectId(projectId);
    setIsInvitationModalOpen(true);
  };

  const openGitHubInvitationModal = (projectId) => {
    setInvitationProjectId(projectId);
    setGitHubInvitationModalOpen(true);
  }

  const closeInvitationModal = () => {
    setIsInvitationModalOpen(false);
  };

  const handleGitHubInvite = async () => {
    const response = await dispatch(inviteGitHubUser({ projectId: invitationProjectId, gitHubUserName: gitHubUsername })).unwrap();
    if (response) {
      let errorMessage = null;
      let successMessage = null;
      if (response.error_messages && response.error_messages.length > 0) {
        errorMessage = response.error_messages.join('\n');
      }
      if (response.success_messages && response.success_messages.length > 0) {
        successMessage = response.success_messages.join('\n');
      }
      const finalMessage = [errorMessage, successMessage].filter(Boolean).join('\n\n');
      openSnackbar({ message: finalMessage, severity: "info" });
      setTimeout(() => {
        closeGitHubInvitationModal();
      }, 500)
    }
  }

  const closeGitHubInvitationModal = () => {
    setGitHubInvitationModalOpen(false);
    setGitHubUsername(null);
  }

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._+\-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    return emailRegex.test(email);
  };

  const handleInviteByEmail = async () => {
    if (inviteName === "") {
      setNameError('Please enter a name.');
      return;
    }

    if (!validateEmail(inviteEmail)) {
      setEmailError('Please enter a valid email address.');
      return;
    }

    if (setSelectedInviteRole === "") {
      setEmailError('Role is not selected for this project.');
      return;
    }

    setNameError('');
    setEmailError('');
    setIsSending(true);

    const res = await dispatch(
      inviteByEmail({ email: inviteEmail, role: selectedInviteRole, projectId: invitationProjectId, name: inviteName })
    );
    if (res.payload?.message) {
      MixpanelService.track("member_invited", { project_id: invitationProjectId });
      fetchMembers();
      setInviteEmail('');
      setInviteName('');
      setSelectedInviteRole('');
      openSnackbar({ message: res.payload?.message, severity: 'success' });
      setIsInvitationModalOpen(false);
    } else {
      openSnackbar({ message: res?.payload?.error || 'Failed to send the invitation. Please try again.', severity: 'error' });
    }

    setIsSending(false);
  };

  const onProjectUpdate = (project) => {
    dispatch(setSelectedProject(project));
    localStorage.setItem(
      'lastSelectedProject',
      JSON.stringify(project)
    );
  }

  const confirmDeleteMember = async () => {
    const response = await dispatch(
      deleteProjectMember({
        projectId: selectedProject.id,
        memberId: selectedMemberId,
      })
    );

    if (response?.payload?.message) {
      MixpanelService.track("member_removed", { project_id: selectedProject?.id });
      openSnackbar({ message: response.payload.message, severity: 'success' });
      fetchMembers();
    } else if (response?.payload?.error) {
      openSnackbar({ message: response.payload.error, severity: 'error' });
    }

    setOpenDeleteConfirmation(false);
  };

  const toggleDropdown = () => {
    setDropdownVisible(!dropdownVisible);
  };

  const handleProfileClick = () => {
    setDropdownVisible(false);
    toggleProfileScreenDialog();
  };

  const toggleProfileScreenDialog = () => {
    setIsProfileScreenDialogOpen(!isProfileScreenDialogOpen);
  };

  const handleSettingsClick = () => {
    setDropdownVisible(false);
    history.push("/settings/");
  }

  const handleTransactionsClick = () => {
    setDropdownVisible(false);
    history.push("/transactions/");
  }

  const CustomDropdown = () => (
    <Box
      ref={dropdownRef}
      sx={{
        position: 'absolute',
        bottom: "10px",
        left: "240px",
        zIndex: 99999999,
        mt: '2px',
        border: '1px solid var(--borderColor)',
        borderRadius: '4px',
        backgroundColor: 'var(--background-primary)',
        minWidth: '120px',
        boxShadow: '0px 2px 4px rgba(0,0,0,0.1)',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Box
        sx={{
          padding: '8px 0',
        }}
      >
        {/* <Button
          sx={{ justifyContent: 'flex-start' }}
          fullWidth
          onClick={handleProfileClick}
        >
          Profile
        </Button> */}

        <Button
          sx={{ justifyContent: 'flex-start' }}
          fullWidth
          onClick={handleTransactionsClick}
        >
          Transactions
        </Button>


        <Button
          sx={{ justifyContent: 'flex-start' }}
          fullWidth
          onClick={handleSettingsClick}
        >
          Settings
        </Button>
        <Button
          sx={{ justifyContent: 'flex-start' }}
          fullWidth
          onClick={handleLogout}
        >
          Logout
        </Button>
      </Box>
    </Box>
  );


  const handleRoleChange = async (newRole, selMember) => {

    try {
      const res = await dispatch(updateUserRoleForProject({ memberId: selMember.id, role: newRole }));
      if (res.payload) {
        MixpanelService.track("member_role_changed", { project_id: selectedProject?.id });
        setFilteredMembers((prevMembers) =>
          prevMembers.map((member) =>
            member.id === selMember.id ? { ...member, role: newRole } : member
          )
        );
      } else {
        openSnackbar({ message: "Failed to update the role. Please try again.", severity: 'error' });
      }
    } catch (error) {
      console.error("Error updating role:", error);
    }
  };

  const handleInviteRoleSelected = (event) => {
    setSelectedInviteRole(event.target.value);
  }

  const RenderToolbar = () => {
    if (customHeaderMenuItems.indexOf(selectedMenuItem) === -1) {
      let title;
      let subtitleText;
      if (selectedMenuItem === "dashboard") {
        title = "Dashboard";
        subtitleText = "Monitor your API testing metrics"
      } else if (selectedMenuItem === "collections") {
        title = "Collections";
        subtitleText = "Create/edit collections, entities"
      } else if (selectedMenuItem === "members") {
        title = "Team Members";
        subtitleText = "Invite/remove team members"
      } else if (selectedMenuItem === "ai-agent") {
        title = "AI Agent";
        subtitleText = "Automate your API testing"
      }
      return (
        <Box className="toolbar-container" sx={{
          borderBottom: "none",
          height: "60px",
          position: "relative",
          zIndex: 5,
          overflow: "hidden",
          boxShadow: "0px 0px 1px 0.5px var(--borderColor)",
        }}>
          <Toolbar variant="dense" className="tool-bar-style" sx={{ zIndex: 2, height: "100%" }}>
            <Grid container direction="row" alignItems="center" justifyContent="space-between" sx={{ padding: "8px 20px" }}>
              <Grid item>
                <Grid container direction="column" justifyContent="center">
                  <Grid item sx={{ padding: "14px 0px" }}>
                    <h4 style={{ margin: '0px', fontSize: '20px' }}>
                      {title}
                    </h4>
                    <span className='truncate-1-lines text-[var(--text-tertiary)] text-[14px]'>
                      {subtitleText}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              {selectedMenuItem === "dashboard" && (
                <Grid item sx={{
                  '& .book-demo-button': {
                    padding: '4px 12px',
                    width: '100%',
                    backgroundColor: 'var(--background-primary)',
                    border: '1px solid var(--primary-color)',
                    color: 'var(--text-primary)',
                    textAlign: 'center',
                    fontSize: '12px',
                    fontWeight: 400,
                    transition: 'all 0.2s ease',
                    borderRadius: "var(--radius-md)",
                    '&:hover': {
                      backgroundColor: 'var(--hover-bg)',
                    }
                  }
                }}>
                  <PopupButton
                    url={customUtils.calendlyDemoUrl}
                    rootElement={document.getElementById('root')}
                    text="Book a Demo"
                    className="book-demo-button listItemButton"
                  />
                </Grid>
              )}
            </Grid>
          </Toolbar>
        </Box>
      )
    }
  };


  const RenderTeamMembers = () => {
    return (
      <div style={{ width: '100%', padding: "40px", maxHeight: "calc(100vh - 65px)", overflowY: "auto" }}>
        {/* <Typography variant="h5">Team Members</Typography> */}
        <Box display="flex" justifyContent="space-between" my={2}>
          <div>
            <Button
              variant={filter === 'all' ? 'contained' : 'outlined'}
              onClick={() => setFilter('all')}
            >
              All
            </Button>
            <Button
              variant={filter === 'joined' ? 'contained' : 'outlined'}
              style={{ marginLeft: '10px' }}
              onClick={() => setFilter('joined')}
            >
              Joined Users
            </Button>
            <Button
              variant={filter === 'pending' ? 'contained' : 'outlined'}
              style={{ marginLeft: '10px' }}
              onClick={() => setFilter('pending')}
            >
              Pending Users
            </Button>
          </div>
          <div className='flex gap-2'>
            {(selectedProject?.github_repo_url) && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => openGitHubInvitationModal(selectedProject.id)}
              >
                <span className='font-normal'>Invite GitHub User</span>
              </Button>
            )}
            {(selectedProject?.role === 'admin') && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => openInvitationModal(selectedProject.id)}
              >
                <span className='font-normal'>Invite New Member</span>
              </Button>
            )}
          </div>
        </Box>
        <table>
          <thead className="bg-[var(--background-primary)]">
            <tr>
              <th className='font-semibold'>Name</th>
              <th className='font-semibold'>Email</th>
              <th className='font-semibold'>Role</th>
              <th className='font-semibold'>Status</th>
              {(selectedProject?.role === 'admin') && <th className='font-semibold'>Action</th>}
            </tr>
          </thead>
          <tbody>
            {filteredMembers.map((member) => (
              <tr className="hover:bg-[var(--hover-bg)]" key={member.id}>
                <td>{member.name || ''}</td>
                <td>{member.email}</td>
                <td>
                  {selectedProject?.role === 'admin' && user.id !== member.user_id ? (
                    <Select
                      value={member.role}
                      onChange={(event) => handleRoleChange(event.target.value, member)}
                      displayEmpty
                      inputProps={{ 'aria-label': 'Without label' }}
                      variant="outlined"
                      sx={{
                        padding: '0',
                        margin: '0',
                        '& .MuiSelect-select': {
                          padding: '10px',
                          border: 'none',
                        },
                        '&:focus': {
                          outline: 'none',
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                          border: 'none',
                        },
                      }}
                    >
                      <MenuItem value="admin">Admin</MenuItem>
                      <MenuItem value="editor">Editor</MenuItem>
                      <MenuItem value="viewer">Viewer</MenuItem>
                    </Select>
                  ) : (
                    <span>{member.role}</span>
                  )}
                </td>

                <td>{member.status || ''}</td>
                {selectedProject?.role === 'admin' && user.id === member.user_id ? (
                  <td>
                    <IconButton
                      onClick={() => { }}
                      style={{ opacity: 0.8 }}
                      disabled
                    >
                      <DeleteIcon />
                    </IconButton>
                  </td>
                ) : (
                  selectedProject?.role === 'admin' && user.id !== member.user_id && (
                    <td>
                      <IconButton onClick={() => { setSelectedMemberId(member.id); setOpenDeleteConfirmation(true); }}>
                        <DeleteIcon />
                      </IconButton>
                      <ConfirmationDialog
                        open={openDeleteConfirmation}
                        onClose={() => { setSelectedMemberId(null); setOpenDeleteConfirmation(false); }}
                        onConfirm={confirmDeleteMember}
                        title="Confirm Delete"
                        content="Are you sure you want to delete?"
                      />
                    </td>
                  )
                )}
              </tr>
            ))}
          </tbody>
        </table>
        <Typography variant="body1">
          Total Members: {filteredMembers.length}
        </Typography>
        <LoadingOverlay open={isLoading} />
      </div>
    );
  };

  const getProjectButton = useMemo(() => (
    <Button
      variant="contained"
      size="large"
      className="selectProjectButton"
      onClick={handleSelectClick}
    >
      <div className="project">
        <span className="projectName truncate-1-lines" title={selectedProject?.name}>{selectedProject?.name}</span>
        <span className="orgName truncate-1-lines" title={selectedOrganisation?.name}>{selectedOrganisation?.name}</span>
      </div>
      <span className="icon-button" id="projects">
        <UnfoldMoreIcon />
      </span>
    </Button>
  ), [selectedProject?.id, selectedOrganisation?.id]);

  const isMenuItemDisabled = useCallback((itemId) => {
    const allowedItems = [...eligibleForSidebar];
    return !allowedItems.includes(itemId);
  }, []);

  const parentNode = useMemo(() => {
    const parents = Object.keys(sideBarDropdownMap);
    let parentId;
    for (let i = 0; i < parents.length; i++) {
      if (sideBarDropdownMap[parents[i]].indexOf(selectedMenuItem) !== -1) {
        parentId = parents[i];
        break;
      }
    }
    return parentId ? [parentId] : [];
  })


  const RenderSidebar = useCallback(() => {
    const filteredMenuItems = menuItems.filter((item) => {
      if (user?.email?.includes('postman') && item.id === 'collections') {
        return false;
      }
      return true;
    });
    return (
      <>
        <NavigationDrawer
          isItemDisabled={isMenuItemDisabled}
          drawerItems={[filteredMenuItems]}
          selectedMenuItem={selectedMenuItem}
          onProfileClick={toggleDropdown}
          profileDropdownRef={dropdownRef}
          onProjectSelect={handleSelectClick}
          getProjectButton={getProjectButton}
          selectedNodeIdInitial={selectedMenuItem}
          expandedNodeIdsInitial={parentNode}
        />
        {dropdownVisible && <CustomDropdown />}
      </>
    )
  }, [selectedMenuItem, selectedProject, selectedOrganisation?.id, dropdownVisible]);

  const ProjectSidebar = () => {
    return (
      <Menu
        anchorEl={projectMenuAnchor}
        open={Boolean(projectMenuAnchor)}
        onClose={handleCloseProjectMenu}
        PaperProps={{
          sx: {
            width: "280px",
            maxHeight: "400px",
            overflowY: 'auto',
            mt: 1,
            backgroundColor: "var(--background-primary) !important",
            backgroundImage: "none",
            border: "1px solid var(--borderColor)"
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box
          sx={{
            p: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            height: 'auto'
          }}
        >
          <span className='fs13'>
            Your Organisations
          </span>
          <Tooltip title="Add Organisation" placement="top-start">
            <IconButton
              color="primary"
              onClick={(e) => {
                e.stopPropagation();
                openModalOrg();
                handleCloseProjectMenu();
              }}
              aria-label="add organisation"
              sx={{ p: 0.5 }}
            >
              <AddCircleOutlineIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>
        <Divider />
        <Box sx={{ maxHeight: "300px", overflowY: 'auto' }}>
          {organisations.map((org) => (
            <Box key={org.id} sx={{ borderTop: 1, borderColor: 'divider' }}>
              <List component="nav" aria-label="organisation projects">
                <ListItem
                  sx={{ padding: '4px 8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                >
                  <Tooltip title={org.name.toUpperCase()} placement="top-start">
                    <ListItemText
                      className="truncate-1-lines"
                      primary={org.name.toUpperCase()}
                      primaryTypographyProps={{ fontWeight: '500', fontSize: '0.75rem' }}
                    />
                  </Tooltip>
                  {org.is_owner && (
                    <Tooltip title="Add Project" placement="top-start">
                      <IconButton
                        color="primary"
                        aria-label="add project"
                        onClick={(e) => {
                          e.stopPropagation();
                          openModal(org);
                          handleCloseProjectMenu();
                        }}
                        sx={{ p: 0.5 }}
                      >
                        <AddCircleOutlineIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  )}
                </ListItem>
                {org.projects.map((project) => (
                  <ListItem
                    button
                    key={project.id}
                    onClick={() => {
                      handleProjectClick(project);
                      handleCloseProjectMenu();
                    }}
                    sx={{
                      backgroundColor:
                        selectedProject && selectedProject.id === project.id
                          ? 'var(--project-menu-bg)'
                          : 'inherit',
                      // border: selectedProject && selectedProject.id === project.id
                      //   ? "1px solid var(--borderColor)" : "none",
                      padding: '2px 8px',
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: '0', mr: 0.5 }}>
                      <FolderIcon fontSize="small" />
                    </ListItemIcon>
                    <Tooltip title={project.name} placement="top-start">
                      <ListItemText
                        primaryTypographyProps={{ fontWeight: '400', fontSize: '13px' }}
                        className="truncate-1-lines fs11" primary={project.name} />
                    </Tooltip>
                  </ListItem>
                ))}
              </List>
            </Box>
          ))}
        </Box>
      </Menu>
    );
  };

  const { isSidebarCollapsed } = useSidebar();

  return (
    <>
      <Box
        className="main-content-container"
        id="app"
        style={{ height: "100vh", display: "flex" }}
      >
        <RenderSidebar />

        <Box
          sx={{ flexGrow: 1 }}
          style={{
            maxWidth: `calc(100% - ${isSidebarCollapsed ? COLLAPSED_WIDTH : drawerWidth}px)`,
            transition: 'max-width 0.3s ease-in-out',
            maxHeight: "calc(100vh - 45px)"
          }}
        >
          <div>
            <AiAgentHeader handleSelectClick={handleSelectClick} />
            {(selectedMenuItem !== "collections" && selectedMenuItem !== "ai-agent") && <RenderToolbar />}

            {selectedMenuItem === "dashboard" && selectedProject && (
              <DashboardPage projectId={selectedProject.id} />
            )}

            {selectedMenuItem === "members" && <RenderTeamMembers />}
            {selectedMenuItem === "supabase_callback" && selectedProject && <SupabaseComponent />}
            {selectedMenuItem === "github_callback" && selectedProject && <GithubComponent />}

            {selectedMenuItem === "collections" && selectedProject && (
              <CollectionSidebar />
            )}
            {selectedMenuItem === "test-scenarios" && selectedProject && (
              <TestScenariosPage
                testScenarioId={selectedTestScenarioId}
                buildId={selectedTestScenarioBuildId}
              />
            )}
            {selectedMenuItem === "test-scenario-builds" && selectedProject && (
              <TestScenarioBuildPage
                project={selectedProject}
                testScenarioId={selectedTestScenarioId}
                buildId={selectedTestScenarioBuildId}
              />
            )}

            {selectedMenuItem === "environments" && selectedProject && (
              <VariableSetPage
                project={selectedProject}
                variableSetId={selectedVariableSetId}
              />
            )}

            {selectedMenuItem === "memory" && selectedProject && (
              <MemoryPage
                projectId={selectedProject?.id}
              />
            )}

            {selectedMenuItem === "test-suites" && selectedProject && (
              <TestSuitesPage
                project={selectedProject}
                testSuiteId={selectedTestSuiteId}
              />
            )}
            {selectedMenuItem === "test-suite-builds" && selectedProject && (
              <TestSuiteBuildsPage
                project={selectedProject}
                testSuiteId={selectedTestSuiteId}
                buildId={selectedTestSuiteBuildId}
              />
            )}
            {selectedMenuItem === "test-plans" && selectedProject && (
              <TestPlanPage
                project={selectedProject}
                testPlanId={selectedTestPlanId}
              />
            )}
            {selectedMenuItem === "test-plan-builds" && selectedProject && (
              <TestPlanBuildPage
                project={selectedProject}
                testPlanId={selectedTestPlanId}
                buildId={selectedTestPlanBuildId}
              />
            )}
            {selectedMenuItem === "build-reports" && selectedProject && (
              <BuildReportsPage
                projectId={selectedProject?.id}
              />
            )}
            {selectedMenuItem === "js-functions" && selectedProject && (
              <FunctionsPage
                projectId={selectedProject?.id}
              />
            )}
            {selectedMenuItem === "settings" && selectedProject && (
              <SettingsPage
                onOrganisationUpdate={fetchOrganisations}
                onProjectUpdate={onProjectUpdate}
              />
            )}
            {selectedMenuItem === "public-page" && selectedProject && (
              <PublicPage
                project={selectedProject}
                onUpdate={onProjectUpdate}
              />
            )}
            {selectedMenuItem === "search" && selectedProject && (
              <ChatsPage
                project={selectedProject}
                chatId={selectedChatId}
              />
            )}
            {selectedMenuItem === "faqs" && selectedProject && (
              <FAQPage
                project={selectedProject}
                faqSlug={selectedFaqSlug}
              />
            )}
            {selectedMenuItem === "collection-forks" && selectedProject && (
              <CollectionForksPage
                project={selectedProject}
              />
            )}
            {selectedMenuItem === "transactions" && selectedProject && (
              <TransactionHistory
                projectId={selectedProject?.id}
              />
            )}
            {selectedMenuItem === "ai-agent" && selectedProject && (
              <TestCaseGeneratorBot
                project={selectedProject}
              />
            )}

            {selectedMenuItem === "api-overview" && selectedProject && (
              <ApiOverview
                project={selectedProject} />
            )}

            {selectedMenuItem === "quick-start" && selectedProject && (
              <QuickStart project={selectedProject} />
            )}

            <ProjectSidebar />
          </div>

          {isModalOpen && (
            <>
              <Box className="modal-overlay" ref={projectModalRef}>
                <ProjectScreen
                  org={orgId}
                  onChild={closeModal}
                  updateSelectedProject={updateSelectedProject}
                />
              </Box>
            </>
          )}
          {isOrgModalOpen && (
            <>
              <Box className="modal-overlay" ref={orgModalRef}>
                <OrganisationScreen onChild={closeModal} />
              </Box>
            </>
          )}
          {isProfileScreenDialogOpen && (
            <>
              <Box className="modal-overlay" ref={profileModalRef}>
                <ProfileScreen
                  user={user}
                  onChild={toggleProfileScreenDialog}
                />
              </Box>
            </>
          )}
        </Box>
      </Box>

      <Dialog
        open={isInvitationModalOpen}
        onClose={isSending ? null : closeInvitationModal}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Invite New Member</DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <DialogContentText>
            To invite a user, please enter their name, email address and select a role.
          </DialogContentText>

          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              autoFocus
              margin="dense"
              id="email"
              label="Email Address"
              type="email"
              fullWidth
              value={inviteEmail}
              onChange={(e) => setInviteEmail(e.target.value)}
              error={!!emailError}
              helperText={emailError || emailSentMessage}
              disabled={isSending}
            />
          </Box>

          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Name" fullWidth
              value={inviteName}
              onChange={(e) => setInviteName(e.target.value)}
              error={!!nameError}
              helperText={nameError || nameSentMessage}
              disabled={isSending}
            />
          </Box>

          <FormControl fullWidth margin="dense" sx={{ mb: 2 }}>
            <InputLabel id="role-select-label">Role</InputLabel>
            <Select
              labelId="role-select-label"
              id="role-select"
              value={selectedInviteRole}
              onChange={handleInviteRoleSelected}
              disabled={isSending}
              style={{ marginTop: 6 }}
            >
              <MenuItem value="Admin">Admin</MenuItem>
              <MenuItem value="Editor">Editor</MenuItem>
              <MenuItem value="Viewer">Viewer</MenuItem>
            </Select>
          </FormControl>

          {generatedLink && (
            <Typography variant="body2">
              Invite Link: {generatedLink}
            </Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeInvitationModal}
            variant="outlined"
            color='error'
            disabled={isSending}
          >
            Close
          </Button>
          <Button
            onClick={handleInviteByEmail}
            color="primary"
            variant="contained"
            disabled={isSending || !selectedInviteRole}
          >
            Invite by Email
          </Button>
        </DialogActions>
      </Dialog>
      <CustomSnackbar
        open={snackbarOpen}
        handleClose={() => {
          setSnackbarOpen(false);
        }}
        message="API Key copied to clipboard"
        severity="success"
      />

      <Dialog
        open={gitHubInvitationModalOpen}
        onClose={closeGitHubInvitationModal}
        aria-labelledby="GitHub Invitation"
      >
        <DialogTitle>Invite GitHub User</DialogTitle>
        <DialogContent sx={{ p: 3 }}>
          <DialogContentText>
            To invite a user, please enter their username. Your GitHub Repo Url: <a href={selectedProject?.github_repo_url} target="_blank" rel="noopener noreferrer">
              {selectedProject?.github_repo_url}
            </a>
          </DialogContentText>
          <Box sx={{ mt: 2, mb: 2 }}>
            <TextField
              autoFocus
              margin="dense"
              id="username"
              label="GitHub Username"
              type="text"
              fullWidth
              value={gitHubUsername}
              onChange={(e) => setGitHubUsername(e.target.value)}
              helperText={"Please enter a GitHub username. To invite multiple users, provide usernames separated by commas (e.g., qodex, support)."}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={closeGitHubInvitationModal}
            variant="outlined"
            color='error'
          >
            Close
          </Button>
          <Button
            onClick={handleGitHubInvite}
            color="primary"
            variant="contained"
            disabled={gitHubUsername === null || gitHubUsername === ""}
          >
            Invite
          </Button>
        </DialogActions>
      </Dialog>

      <IntroTour open={showGuideModal} onClose={() => setShowGuideModal(false)} />
    </>
  );
};

function mapStateToProps(state, ownProps) {
  return {
    ...ownProps,
    selectedProject: state.common.selectedProject,
    selectedOrganisation: state.common.selectedOrganisation,
    organisations: state.common.organisations,
    user: state.user.current_user
  }
}

export default connect(mapStateToProps)(DashboardScreen);